import ClaimsHeader from "./CarriersHeader"
import CompanyLinks from "./CompanyLinks"
import Footer from "../../shared/Footer"

function Carriers() {
  return (
    <>
        <ClaimsHeader />
        <CompanyLinks />
        <Footer />
    </>
  )
}

export default Carriers